import { createElement } from 'react';
const ImageItem = (props) => {

    const { attributes, slide, index, classNames = {} } = props;
    const { isLazyLoad, title, titleFCaption } = attributes;
    const { tag = "h5" } = title;

    const { img, title: slideTitle, desc, btnLabel, btnUrl, target, altText } = slide || {};
    const titleCheck = titleFCaption ? img?.caption || img?.title : slideTitle != null ? slideTitle : img?.caption || img?.title;

    return <div className={`item ${index === 0 ? 'active' : ''} ${classNames.item || ''}`}>
        <div className="img">
            {img?.url && <> {isLazyLoad ?
                <img loading="lazy" data-src={img.url} className="d-block w-100 lazyload" alt={altText || img?.alt || img?.title} /> :
                <img src={img.url} className="d-block w-100" alt={altText || img?.alt || img?.title} />}</>}
        </div>

        <div className={classNames.contentArea || 'content-area'}>
            <div className={`captionContent ${classNames.captionContent || ''}`}>
                {(slideTitle || img?.caption || img?.title) && createElement(tag, {
                    className: `bsbTitle ${classNames.title || ''}`, dangerouslySetInnerHTML: { __html: titleCheck }
                }, null)}

                {desc && <>
                    <p className={classNames.desc || ''} dangerouslySetInnerHTML={{ __html: desc }} />
                </>}
                {btnLabel && <>
                    <div className={`carousel-button ${classNames.btn || ''}`}>
                        <a href={btnUrl} target={target ? '_blank' : ''} rel="noreferrer" dangerouslySetInnerHTML={{ __html: btnLabel }} />
                    </div>
                </>}
            </div>
        </div>
    </div>
}
export default ImageItem;